import { Spin } from 'antd'
import styled from 'styled-components'

const StyledCheckboxSpinner = styled(Spin)`
  margin-right: 10px;
  font-size: 13px;
`

export default StyledCheckboxSpinner
